package com.caleb.k.models

enum class Experience(
    val number: String,
    val jobPosition: String,
    val company: String,
    val from: String,
    val to: String,
    val bullet1:String,
    val bullet2: String,
    val bullet3: String,
    val bullet4: String,
    val bullet5: String,
    val bullet6: String,
    val bullet7: String,
    val bullet8: String,
    val bullet9: String,
    val bullet10: String,
) {
    First(
        number = "01",
        jobPosition = "Open Source Developer- Volunteer",
        company = "Pocketcast",
        from = "June 2023",
        to = "December 2023",
        bullet1 = "At Pocket Casts, I work as an Open Source Developer being responsible for assisting the mobile team in developing the native mobile app entirely in Kotlin, adhering to Modern Android Best Practices. My roles and responsibilities included the following but not limited to: ",
        bullet2 = "- Shipping stable, production ready features.",
        bullet3 = "- Migration from XML to Jetpack Compose and following best practices.",
        bullet4 = "- Maintain legacy apps by fixing bugs and releasing improvements ensuring stability of greater than 85%",
        bullet5 = "- Improving test coverage from about 50% to 65%.",
        bullet6 = "- Migrating legacy code to modern practices like RxJava to Kotlin coroutines (for concurrency).",
        bullet7 = "-  Collaborating with Global remote teams.",
        bullet8 = "",
        bullet9 = "",
        bullet10 = "",
    ),
    Second(
        number = "02",
        jobPosition = "Android Developer (Remote)",
        company = "Greenstand",
        from = "December 2022",
        to = "September 2023",
        bullet1 = "In my role at Greenstand, I've been an integral part of a dynamic engineering team, contributing to the innovative reforestation initiatives by leveraging cutting-edge technology. My roles and Responsibilities included but not limited to: ",
        bullet2 = "- Maintain legacy apps by fixing bugs and releasing improvements ensuring stability of greater than 80%",
        bullet3 = "- Increased Unit Test Coverage from about 15% to about 65% and add CI pipelines to ensure stability of the app",
        bullet4 = "- Worked closely with the design team to break down user requirements and build user personas, develop requirements canvas, and finally come up with technical requirements and roadmaps.",
        bullet5 = "- Collaborate with product managers, QA, UI/UX, and backend to deliver products with clean user interfaces",
        bullet6 = "- Develop stable data-driven and product-driven android features for the app",
        bullet7 = "",
        bullet8 = "",
        bullet9 = "",
        bullet10 = "",
    ),
    Third(
        number = "03",
        jobPosition = "Open Source Developer- Volunteer",
        company = "Stax",
        from = "Feb 2023",
        to = "May 2023",
        bullet1 = "At Stax Payments, I worked as an OPEN SOURCE Developer playing a pivotal role in maintaining and advancing our cutting-edge payment processing solution, which excels in automating USSD transactions for businesses. My roles and responsibilities included the following but not limited to: ",
        bullet2 = "- Modularization of the Stax App to a multi-module application also focusing on SOLID principles. ",
        bullet3 = "- Collaborate with team members to improve unit test code coverage from 20% to 35%",
        bullet4 = "- Introduction of better practices such as dependency injection (DI) using Hilt and migrating from Koin",
        bullet5 = "- Automated testing of codebase through techniques like test-driven development",
        bullet6 = "- Writing and maintaining new (continuous integration) CI/CD systems using GitHub Actions and handling releases using Github packages",
        bullet7 = "",
        bullet8 = "",
        bullet9 = "",
        bullet10 = "",
    ),
    Fourth(
        number = "04",
        jobPosition = "Freelancer Android Developer",
        company = "Upwork",
        from = "June 2021",
        to = "November 2022",
        bullet1 = "As a self-employed Android Developer operating on platforms such as Upwork, I brought a wealth of expertise in Kotlin, Jetpack Compose, Data binding, XML, Unit testing, UI Testing, Clean Architecture, and collaboration to various projects. Key highlights of my freelance role include:",
        bullet2 = "- Work on user interfaces from Figma and Adobe using both Jetpack Compose and XML",
        bullet3 = "- Maintaining legacy code by fixing bugs and migrating to latest app architecture patterns e.g. MVP to MVVM (Model-View-ViewModel), app modularization etc.",
        bullet4 = "- Migrating legacy code to modern practices like Kotlin coroutines (for concurrency), Dagger Hilt for dependency injection (DI) and Retrofit",
        bullet5 = "- Working with outside data sources and API Third Parties.\n",
        bullet6 = "- Maintain standards in android development using clean architectural design patterns\n",
        bullet7 = "- Writing unit tests for the code  including edge cases, usability and general reliability and deploy on the Playstore periodically \n",
        bullet8 = "",
        bullet9 = "",
        bullet10 = "",
    ),

}